"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImpersonationEnabled = void 0;
var utils_1 = require("../utils");
var isImpersonationEnabled = function () {
    return !(0, utils_1.getBoolean)(process.env.REACT_APP_IMPERSONATION_DISABLED);
};
exports.isImpersonationEnabled = isImpersonationEnabled;
